import React, { useEffect } from "react";
import OrderCanceled from "../Myorders/OrderCanceled";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";

const CancelOrders = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <OrderCanceled />
      <Footer />
    </>
  );
};

export default CancelOrders;
